/**
 * Global fixed "Book an Appointment" button.
 * - Hides (fades out + pointer-events: none) once the footer scrolls into view,
 *   so it never overlaps the footer. Runs on every page.
 * - On homepage, stays hidden until the first viewport boundary has fully left
 *   the visible viewport.
 * - On the homepage, while the button overlays the hero section, it uses the
 *   alternative colour scheme; once the hero scrolls past it reverts to the
 *   primary scheme.
 */
export default (el) => {
  const button = el.querySelector('.btn')
  if (!button) return

  // --- Hide the button once the footer is in view ---
  const footer = document.querySelector('.redesign-footer')
  if (footer && 'IntersectionObserver' in window) {
    const footerObserver = new window.IntersectionObserver((entries) => {
      el.classList.toggle('is-hidden', entries[0].isIntersecting)
    })
    footerObserver.observe(footer)
  }

  // --- First viewport reveal (homepage) ---
  const getRevealBoundary = () => document.querySelector('[data-book-button-reveal-boundary]')
  const hasRevealGate = getRevealBoundary() || el.classList.contains('is-reveal-hidden')

  const applyRevealState = () => {
    const revealBoundary = getRevealBoundary()

    if (!revealBoundary) {
      return
    }

    const boundaryBottom = revealBoundary.getBoundingClientRect().bottom

    el.classList.toggle('is-reveal-hidden', boundaryBottom > 0)
  }

  // --- Hero colour scheme (homepage only, alternative scheme set) ---
  const hero = document.querySelector('[data-home-hero]')
  const primary = el.dataset.schemePrimary || 'default'
  const alt = el.dataset.schemeAlt || 'none'
  const hasHeroScheme = hero && alt !== 'none'

  if (!hasRevealGate && !hasHeroScheme) return

  let ticking = false

  const apply = () => {
    applyRevealState()

    if (hasHeroScheme) {
      // el is fixed, so its rect.top is constant; the hero's bottom moves on scroll
      const overHero = hero.getBoundingClientRect().bottom > el.getBoundingClientRect().top
      button.classList.toggle('btn--white', (overHero ? alt : primary) === 'white')
    }

    ticking = false
  }

  const onScroll = () => {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(apply)
  }

  apply()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })
}
